import axios from "axios";
import { Post, Section } from "../common/types/post.types";
import { GetAllPostApiType, ResponsePaginationType, ResponsePostStatisticType } from "../common/types/api.types";

const domain = process.env.REACT_APP_SERVER_DOMAIN;

export async function getFileContent(path: string) {
  const res = await axios.get(path);
  return res.data;
}

export async function getHierarchySectionsApi(): Promise<Section[]> {
  const res: any = await axios.get(`${domain}/api/v1/posts/sections`)
  return res?.data?.data;
}

export async function getAllPostsApi(params: GetAllPostApiType): Promise<ResponsePaginationType<any>> {
  const res: any = await axios.get(`${domain}/api/v1/posts`, {
    params
  })

  return res?.data
}

export async function getPostDetailApi(id: number): Promise<Post> {
  const res: any = await axios.get(`${domain}/api/v1/posts/${id}`)

  return res?.data?.data
}

export async function getPostStatisticApi(): Promise<ResponsePostStatisticType[]> {
  const res: any = await axios.get(`${domain}/api/v1/posts/sections/statistic`)

  return res?.data?.data;
}
